import type {
  PunishmentAction,
  SendMessageAction,
  SupportModeAction,
  TriggerAction,
  TriggerFilter,
  WholeWordFilter
} from "../model/types"

export const isWholeWordFilter = (filter: TriggerFilter): filter is WholeWordFilter => {
  return filter.filter_type === "whole_word"
}

export const isPunishmentAction = (action: TriggerAction): action is PunishmentAction => {
  return action.action_type === "punishment"
}

export const isSendMessageAction = (action: TriggerAction): action is SendMessageAction => {
  return action.action_type === "send_message"
}

export const isSupportModeAction = (action: TriggerAction): action is SupportModeAction => {
  return action.action_type === "support_mode"
}
